import React from "react";
import { ChevronRight, Code, PersonLinesFill } from "react-bootstrap-icons";
import { Link as LinkIcon } from "react-bootstrap-icons";
import * as Styled from "./OutletCard.styled";

export interface OutletCardProps {
  title: string;
  subtitle: string;
  isLinked: boolean;
  isEnabled: boolean;
  onEdit: () => void;
  onToggleEnabled: (enabled: boolean) => void;
  onGoToProfile?: () => void;
  onEmbedCode?: () => void;
}

export const OutletCard: React.FC<OutletCardProps> = ({
  title,
  subtitle,
  isLinked,
  isEnabled,
  onEdit,
  onToggleEnabled,
  onGoToProfile,
  onEmbedCode,
}) => {
  const handleCardClick = (e: React.MouseEvent) => {
    // Only trigger edit if not clicking on controls
    if (!(e.target as HTMLElement).closest('[data-no-propagate]')) {
      onEdit();
    }
  };

  return (
    <Styled.StyledCard onClick={handleCardClick}>
      <Styled.LeftSection>
        <Styled.Title>{title}</Styled.Title>
        <Styled.Subtitle>{subtitle}</Styled.Subtitle>
      </Styled.LeftSection>

      <Styled.RightSection>


        {onGoToProfile && (
          <Styled.ActionIcon
            data-no-propagate
            onClick={(e) => { e.stopPropagation(); onGoToProfile(); }}
            title="Go to linked profile"
          >
            <PersonLinesFill />
          </Styled.ActionIcon>
        )}

        <Styled.LinkStatusIcon $isLinked={isLinked}>
          <LinkIcon />
        </Styled.LinkStatusIcon>

        {onEmbedCode && (
          <Styled.ActionIcon
            data-no-propagate
            onClick={(e) => { e.stopPropagation(); onEmbedCode(); }}
            title="Get embed code"
          >
            <Code />
          </Styled.ActionIcon>
        )}

        <Styled.ControlsWrapper data-no-propagate onClick={(e) => e.stopPropagation()}>
          <Styled.ControlIndicator $isEnabled={isEnabled} />
          <Styled.ControlButton
            $isActive={!isEnabled}
            onClick={() => onToggleEnabled(false)}
            title="Disable"
          >
            ✕
          </Styled.ControlButton>
          <Styled.ControlButton
            $isActive={isEnabled}
            onClick={() => onToggleEnabled(true)}
            title="Enable"
          >
            ✓
          </Styled.ControlButton>
        </Styled.ControlsWrapper>

        <Styled.Circle>
          <ChevronRight />
        </Styled.Circle>
      </Styled.RightSection>
    </Styled.StyledCard>
  );
};
